<template>
	<div class="parameterManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">参数配置</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">参数配置</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增参数配置"></div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%" height="580">
							<el-table-column type="index" label="序号" width="100">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="paramConfigName" label="参数名称" width="230">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="paramType" label="参数类型" width="230">
								<template slot-scope="scope">
									<span>{{getName(scope.row.paramType,parameterList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="paramData" label="数据">
								<template slot-scope="scope">
									<span v-if="scope.row.paramType==1">{{getStr(scope.row.itemNameList)}}</span>
									<span v-else>{{scope.row.paramData}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="paramCode" label="码值" >
								<template slot-scope="scope">
									<span>{{scope.row.paramCode||"-"}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="150">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<div class="dialogBox">
				<el-form :model="itemObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="参数名称" prop="paramConfigName">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.paramConfigName" placeholder="请输入活动名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="参数类型" prop="parameterType">
								<div class="myinputBox">
									<el-select clearable value-key="text" v-model="itemObj.paramType" slot="prepend"
										placeholder="请选择参数类型" @change="changetype($event,itemObj)">
										<el-option v-for="(item,inx) in parameterList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" >
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="码值" prop="paramCode">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.paramCode" placeholder="请输入码值">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart" v-if="itemObj.paramType==2">
							<el-form-item class="lableBox" label="参数数据" prop="paramData">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.paramData" placeholder="请输入参数数据">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div v-if="itemObj.paramType==1" class="parameterBox ">
					<div class="titleBox">筛选项数据</div>
					<div class="flexBox disStart">
						<div class="itemBox disStart" v-for="(item,inx) in itemObj.itemNameList" :key="inx">
							<div class="numItem  disStart">
								<div class="inputBox">
									<el-input v-model="item.value" placeholder=""></el-input>
								</div>
							</div>
							<div class="btnBox disStart">
								<span class="delIcon" @click="btnClick(item,inx,1)"></span>
								<span class="addIcon" v-if="inx==itemObj.itemNameList.length-1"
									@click="btnClick(item,inx,2)"></span>
							</div>
						</div>
					</div>

				</div>

			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSave('ruleForm3')" v-preventReClick="3000">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: "parameterManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				dialogVisible: false,
				NOfalse: false,
				dialogTitle: "新增参数",
				tableData: [],
				loading: false,
				searchObj: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					searchData: [],
				},
				itemObj: {
					itemNameList: [{
						value: ""
					}],
					paramConfigName: "",
					paramType: "",
					paramCode: "",
					paramData: ""
				},
				rules: {
					paramConfigName: [{
						required: true,
						message: '请输入参数名称',
						trigger: 'blur'
					}],
					paramType: [{
						required: true,
						message: '请选择参数类型',
						trigger: 'change'
					}],
					paramCode: [{
						required: true,
						message: '请输入码值',
						trigger: 'change'
					}],
					paramData: [{
						required: true,
						message: '请输入参数数据',
						trigger: 'change'
					}]
				},
				parameterList: [{
						text: "筛选项",
						value: 1
					},
					{
						text: "数据项",
						value: 2
					}
				]
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			changetype(e,item){
				
				if(e==1){
					if(item.itemNameList && item.itemNameList.length>0){
					}else{
						this.$set(item,"itemNameList",[{value:''}])
					}
				}
				
			},
			itemClick(item, n) { //1编辑2删除5新增
			let that=this
				if (n == 1) {
					this.$set(this, "dialogTitle", "编辑参数")
					this.$set(this, "itemObj", item)
					
					this.dialogVisible = true
				} else if (n == 2) {
					this.$confirm('是否确认删除该参数?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteParamConfig({
							paramConfigId: item.paramConfigId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							} else {
								that.$message({
									message: res.returnMessage || "请求异常",
									type: 'error'
								});
							}
						})
					
					}).catch(() => {
					
					});
				} else if (n == 5) {
					this.$set(this, "dialogTitle", "新增参数")
					this.$set(this, "itemObj", {
						itemNameList: [{
							value: ""
						}],
						paramConfigName: "",
						paramType: "",
						paramCode: "",
						paramData: ""
					})
					this.dialogVisible = true
				}
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			getStr(arr) {
				let str = ""
				if (arr[0] && arr[0]) {
					for (let k in arr) {
						if (k == arr.length - 1) {
							str += (arr[k].value)
						} else {
							str += (arr[k].value + ",")
						}
					}
				}
				return str
			},
			getData(n) {
				this.loading=true
				this.$api.listParamConfig({}).then((res) => {
					if (res.returnCode == 200) {
						for (let k of res.obj) {
							if (k.itemNameList && k.itemNameList.length > 0) {
								for (let j in k.itemNameList) {
									this.$set(k.itemNameList, [j], {
										value: k.itemNameList[j]
									})
								}
							}
						}
						this.$set(this, "tableData", res.obj)
						this.loading=false
					}
				})
			},
			isNull(str) {
				var regu = "^[ ]+$";
				var re = new RegExp(regu)
				if (str == "") {
					return false
				} else if (re.test((str))) {
					return false
				} else {
					return true
				}
			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.itemObj.paramType == 1) {
							if (this.itemObj.itemNameList.length <= 0 || !this.itemObj.itemNameList) {
								this.$message({
									type: 'warning',
									message: '最少输入一个筛选项!'
								});
								return false
							} else if (this.itemObj.itemNameList.length > 0) {
								let index = this.itemObj.itemNameList.findIndex((item, inx) => {
									return this.isNull(item.value) == false
								})
								if (index >= 0) {
									this.$message({
										type: 'warning',
										message: '请输入筛选项!'
									});
									return false
								}
							}
						}
						if (this.dialogTitle == "新增参数") {
							this.addParamConfig()
						} else {
							this.updateParamConfig()
						}
					} else {
						return false;
					}
				});
			},
			addParamConfig() {
				let arr = []
				for (let k of this.itemObj.itemNameList) {
					arr.push(k.value)
				}
				let obj = {
					paramConfigName: this.itemObj.paramConfigName, //参数名
					paramType: this.itemObj.paramType, //参数类型 1筛选项 2数据项
					paramCode:this.itemObj.paramCode, //参数码值
					itemNameList: this.itemObj.paramType==1?arr:[], //参数筛选项集合
					paramData: this.itemObj.paramType==2? this.itemObj.paramData:"" //参数数据项数据
				}
				this.$api.addParamConfig(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$message({
							type: 'success',
							message: '新增成功!'
						});
						this.dialogVisible = false
						setTimeout(() => {
							this.getData()
						}, 500)
					}
				})
			},
			updateParamConfig() {
				let arr = []
				for (let k of this.itemObj.itemNameList) {
					arr.push(k.value)
				}
				let obj = {
					paramConfigId: this.itemObj.paramConfigId,
					paramConfigName: this.itemObj.paramConfigName, //参数名
					paramType: this.itemObj.paramType, //参数类型 1筛选项 2数据项
					paramCode:this.itemObj.paramCode, //参数码值
					itemNameList: this.itemObj.paramType==1?arr:[], //参数筛选项集合
					paramData: this.itemObj.paramType==2? this.itemObj.paramData:"" //参数数据项数据
				}
				this.$api.updateParamConfig(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$message({
							type: 'success',
							message: '编辑成功!'
						});
						this.dialogVisible = false
						setTimeout(() => {
							this.getData()
						}, 500)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val, n) {
				this.searchObj.pageNo = val
				this.getData({})

			},
			btnClick(item, inx, n) {
				let that = this
				if (n == 1) {
					if (this.itemObj.itemNameList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保存一个筛选项!'
						});
						return false
					}
					this.itemObj.itemNameList.splice(inx, 1)
				} else {
					this.itemObj.itemNameList.push({
						value: "",
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./parameterManage.scss";
</style>